import { flag } from "components/providers/featureFlags/flagUtils";

export type FeatureFlags = typeof featureFlags;
export type FeatureFlagsWidened = Record<string, ReturnType<typeof flag[keyof typeof flag]>>;

export const featureFlags = {
    "SLS Entries": flag.boolean(true),
    "New scoring UI notification": flag.boolean(true),
    "Event schedule timezone selector": flag.boolean(true),
    "Rego details": flag.boolean(true),
};
